import React, { Component } from 'react';
import { Table, ButtonGroup, Button, Glyphicon, FormControl, Row, Col } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap';
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/workingexperiences/"
const PROJECT_TYPES = {
    0: "project",
    1: "geclusterde opdracht"
}

class WerkervaringOverzicht extends Component {
    constructor() {
        super();
        this.handleDelete = this.handleDelete.bind(this)
        this.handlePaginationClick = this.handlePaginationClick.bind(this)
        this.handleChangePageSize = this.handleChangePageSize.bind(this)
        this.handleClickVerk = this.handleClickVerk.bind(this)
        this.getWorkingExperiences = this.getWorkingExperiences.bind(this)
        this.state = {
            rows: [],
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            },
            currentFetchUrl: '', // To know where to fetch (to refresh companies) if a company is deleted
        }
    }
    handlePaginationClick(e) {
        const FETCH_URL3 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.setState({ currentFetchUrl: FETCH_URL3 })
        this.getKennis(FETCH_URL3)
    }
    handleClickVerk(e) {
        var url = "api/members/" + e + "/getWerk";
        Api.GetApiDownload(url)
    }
    handleChangePageSize(e) {
        this.setState({ pagination: { ...this.state.pagination, pageSize: e.target.value } })
        this.getWorkingExperiences(FETCH_URL + "?PageSize=" + e.target.value)
    }
    // To pass parameters to event handlers while using property initializer syntax, we need to use currying.   
    handleDelete = id => event => {
        event.preventDefault()
        if (window.confirm('Are you sure you wish to delete this item?')) {
            Api.DeleteApi(FETCH_URL + id).then(response => {
                Api.print(`Response delete ${id}`)
                Api.print(response)
                this.getWorkingExperiences() // Update the working experiences list
            })
        }

        else Api.print('Think it better.')

    }
    getWorkingExperiences(url) {
        Api.GetTableApi(url, this.handlePaginationClick).then(response => {
            this.setState({ pagination: response.pagination }) // Pagination object 
            return response.data.json() // Data -> companies object
        }).then(objectData => {
            if (objectData !== undefined) {
                let rows = objectData.workingexperiences.map((we, index) => {
                    let editUrl = `wijzig/${we.id}`
                    return (<tr key={we.id}>
                        <td>{we.reference ? we.reference : '-'}</td>
                        <td>{we.level}</td>
                        <td>{we.company}</td>
                        <td>{we.customer}</td>
                        <td>{PROJECT_TYPES[we.projectType]}</td>
                        <td>{we.project}</td>
                        <td>{we.city}</td>
                        <td>{we.years}</td>
                        <td>{we.file != "" && we.file != null ? <a onClick={() => this.handleClickVerk(we.id)} target="_blank" title={"Bekijk werkewaring"}>bekijk<br /></a> : ""}</td>
                        <td>{we.points}</td>
                        <td>{we.status}</td>
                        <td>
                            <ButtonGroup>
                                {we.edit ? <LinkContainer to={editUrl}>
                                    <Button bsSize="xsmall" className="edit">
                                        <Glyphicon glyph="pencil" />
                                    </Button>
                                </LinkContainer> : ""}
                                {we.remove ? <Button bsSize="xsmall" className="delete" onClick={this.handleDelete(we.id)}>
                                    <Glyphicon glyph="remove" />
                                </Button> : ""}

                            </ButtonGroup></td>
                    </tr >)
                })

                this.setState({ rows: rows })
            }
        })
    }

    componentDidMount() {
        this.getWorkingExperiences(FETCH_URL)
    }

    render() {
        return (
            <div>
                <h5><strong>Overzicht werkervaring</strong></h5>
                <Row>
                    <Col md={1} sm={1}>
                        <FormControl name='pageSize' componentClass="select" placeholder="select" onChange={this.handleChangePageSize} value={this.state.pagination.pageSize}>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="0">All</option>
                        </FormControl>
                    </Col>
                </Row>
                <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>
                <div className={"table-responsive " + this.state.tableclass}>
                    <Table striped bordered hover className="text-center">
                        <thead>
                            <tr>
                                <th>Referentie</th>
                                <th>niveau</th>
                                <th>Werkgever</th>
                                <th>Opdrachtgever</th>
                                <th>Soort</th>
                                <th>Project</th>
                                <th>Locatie</th>
                                <th>Jaar</th>
                                <th>Upload</th>
                                <th>Ee's</th>
                                <th>Akkoord</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.rows}
                        </tbody>
                    </Table>
                </div>
                <div>
                    <div className="paginationStyling">
                        <div style={{ float: 'left' }}>
                            {this.state.pagination.prevButton}
                        </div>
                        <div style={{ float: 'center' }}>
                            Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                        </div>
                        <div style={{ float: 'right' }}>
                            {this.state.pagination.nextButton}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WerkervaringOverzicht;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Werkervaring/WerkervaringOverzicht.js